import application from "./stimulus_application";
import HeaderDropdownController from "./controllers/header_dropdown_controller";
import HeroFormController from "./controllers/hero_form_controller";
import HomepageMobileMenuController from "./controllers/homepage_mobile_menu_controller";

application.register("header-dropdown", HeaderDropdownController);
application.register("hero-form", HeroFormController);
application.register("homepage-mobile-menu", HomepageMobileMenuController);
